import React from 'react';
import {
  FormControl,
  Box,
  FormHelperText,
  TextField,
} from '@mui/material';

export default function IntervalField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  edit,
  outputType,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);

    const valid =
      newValue === '' ||
      (!isNaN(parseInt(newValue)) && parseInt(newValue) % 15 === 0);
    setError(!valid);
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          label='Interval (min)'
          id='interval'
          aria-describedby='interval-helper-text'
          variant='outlined'
          fullWidth
          placeholder='60'
          onChange={handleChange}
          error={Boolean(error)}
          value={value || ''}
          disabled={!outputType || edit}
          type='number'
        />
        {error ? (
          <FormHelperText id='interval-helper-text'>
            Checkpoint Interval Must Be Multiple of 15
          </FormHelperText>
        ) : (
          <FormHelperText id='interval-helper-text'>
            Enter checkpoint interval in minutes (must be multiple of 15)
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

